import { Spinner, Text } from '@viapeople/components'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface HighPerformerByManagerChartProps {
	data:
		| Array<{
				managerId: string
				managerName: string
				directReportCount: number
				highPerformerPercent: number
				avgRating: number
		  }>
		| undefined
	loading?: boolean
}

export function HighPerformerByManagerChart({ data, loading }: HighPerformerByManagerChartProps) {
	if (loading) {
		return (
			<div data-testid='high-performer-manager-loading' className='flex items-center justify-center h-64'>
				<Spinner />
			</div>
		)
	}
	if (!data || data.length === 0) {
		return (
			<div
				data-testid='high-performer-manager-empty'
				className='flex items-center justify-center h-64 text-neutral-500'>
				No manager-level data is available. Configure a hierarchy file to enable this view.
			</div>
		)
	}

	return (
		<div data-testid='high-performer-by-manager-chart' className='w-full'>
			<Text variant='small' weight='semibold' className='mb-2'>
				High Performer % by Manager
			</Text>
			<ResponsiveContainer width='100%' height={300}>
				<BarChart data={data} layout='vertical' margin={{ top: 16, right: 24, left: 64, bottom: 24 }}>
					<CartesianGrid strokeDasharray='3 3' stroke='#e5e7eb' />
					<XAxis type='number' domain={[0, 100]} tick={{ fontSize: 12 }} />
					<YAxis dataKey='managerName' type='category' tick={{ fontSize: 12 }} width={120} />
					<Tooltip
						contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e5e7eb' }}
						formatter={(value: number | undefined) => (value != null ? `${value.toFixed(1)}%` : '-')}
					/>
					<Bar dataKey='highPerformerPercent' fill='#16a34a' name='High Performer %' radius={[0, 2, 2, 0]} />
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}
